// extracted by mini-css-extract-plugin
export var cardLayout = "_80-1";
export var paginationContainer = "_80-0";